import { verificationService } from "services/verfication.service";
import { verificationConstants } from "./actionTypes";

export const verificationActions = {
  verify,
};

export function verify(token) {
  return (dispatch) => {
    dispatch(request(token));

    verificationService.verify(token).then(
      (user) => {
        dispatch(success());
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };

  function request(token) {
    return { type: verificationConstants.CHECK_USER_REQUEST, token };
  }
  function success(message) {
    return { type: verificationConstants.CHECK_USER_SUCCESS, message };
  }
  function failure(error) {
    return { type: verificationConstants.CHECK_USER_FAILURE, error };
  }
}
